import * as THREE from 'three';
import gsap from 'gsap';

export class Scene {
    
    setUp(e) {
  
      this.e=e;

    }
  
    buildScene(){

      this.mainCont = new THREE.Group();
      this.e.scene3D.add(this.mainCont)

      this.dl = new THREE.DirectionalLight(0xffffff, 3);
      this.dl.position.x=-26*3;
      this.dl.position.z=13*3;
      this.dl.position.y=26*3;
      this.mainCont.add(this.dl);

      // this.dl_shad = new THREE.DirectionalLight(0xffffff, 1);
      // this.dl_shad.position.x=12*3;
      // this.dl_shad.position.z=26*3;
      // this.dl_shad.position.y=26*3;
      // this.mainCont.add(this.dl_shad);

      // this.dl_shad.castShadow=true;

      // this.dl_shad.shadow.mapSize.width = 1024;
      // this.dl_shad.shadow.mapSize.height = 1024;
      // // this.dl_shad.shadow.bias = .001;
      
      // this.e.sSize = 11;
      // this.dl_shad.shadow.camera.near = 0.1; 
      // this.dl_shad.shadow.camera.far = 180;
      // this.dl_shad.shadow.camera.left = -this.e.sSize;
      // this.dl_shad.shadow.camera.right = this.e.sSize;
      // this.dl_shad.shadow.camera.top = this.e.sSize;
      // this.dl_shad.shadow.camera.bottom = -this.e.sSize;
      // this.dl_shad.shadow.radius = 2;

      // const shadowHelper = new THREE.CameraHelper(this.dl_shad.shadow.camera);
      // this.mainCont.add(shadowHelper);

      // ambient light

      this.ambLight = new THREE.AmbientLight( 0xffffff, 1 );
      this.mainCont.add( this.ambLight );

      //---PLAYER------------------------------------------------------------------------------------------------------

      this.playerCont = new THREE.Group();
      this.mainCont.add(this.playerCont)
      this.playerCont.position.y=0;
      this.playerCont.position.z=0;
      this.playerCont.position.x=0;

      //---SCENE------------------------------------------------------------------------------------------------------

      var geometry = new THREE.PlaneGeometry(10,10);
      var material = new THREE.MeshBasicMaterial({ color: 0x000000, transparent: true, opacity: 0 });
      this.darkPlane = new THREE.Mesh(geometry, material);
      this.darkPlane.position.z=-5;
      this.mainCont.add(this.darkPlane);

      this.downAmount = -4.3;

      //--------------------------------------------------------

      this.qo = this.e.qo.clone();
      this.qo.scale.x = this.qo.scale.y = this.qo.scale.z = .6;
      this.mainCont.add(this.qo);
      this.qo.rotation.y = this.e.u.ca(135);
      this.qo.position.z=-15;
      this.qo.position.y=1;

      this.qo.traverse((object) => {

        if ( object.isMesh ){

          console.log(object.name);

          if(object.name==="innerCurved"){

            this.matClone = object.material.clone();

            this.innerCurved = object;
            object.material = this.matClone;
            object.material.transparent = true;

          }else if(object.name==="grate"){

            this.matClone = object.material.clone();

            this.grate = object;
            object.material = this.matClone;
            object.material.transparent = true;

          }else if(object.name==="front"){

            this.matClone = object.material.clone();

            this.front = object;
            object.material = this.matClone;
            object.material.transparent = true;

          }else if(object.name==="door_1"){

            this.matClone = object.material.clone();

            this.door1 = object;
            object.material = this.matClone;
            object.material.transparent = true;

          }else if(object.name==="door_2"){

            this.matClone = object.material.clone();

            this.door2 = object;
            object.material = this.matClone;
            object.material.transparent = true;

          }

        }else{

          if(object.name==="door"){

            this.door = object;

          }

        }

      });

      //--------------------------------------------------------

      this.myModel = this.qo;
      
      //--------------------------------------------------------

      this.compCont = new THREE.Group();
      this.compCont.rotation.y = this.e.u.ca(135);
      this.compCont.scale.x = this.compCont.scale.y = this.compCont.scale.z = 0;
      this.compCont.position.y=.4;
      this.compCont.position.z=2;
      this.mainCont.add(this.compCont)

      this.compCont.starty = this.compCont.position.y;
      this.compCont.startz = this.compCont.position.z;

      //--------------------------------------------------------

      this.energyMonitor = this.e.energyMonitor.clone();
      this.compCont.add(this.energyMonitor);
      this.energyMonitor.mats = [];

      this.energyMonitor.traverse((object) => {

        if ( object.isMesh ){

          this.energyMonitor.mats.push(object.material);
          object.material.transparent=true;
          object.material.opacity=0;
          object.material.visible=false;

        }

      });

      //--------------------------------------------------------

      this.breaker = this.e.breaker.clone();
      this.compCont.add(this.breaker);
      this.breaker.mats = [];

      this.breaker.traverse((object) => {

        if ( object.isMesh ){

          this.breaker.mats.push(object.material);
          object.material.transparent=true;
          object.material.opacity=0;
          object.material.visible=false;

        }

      });

      //--------------------------------------------------------

      this.pon = this.e.pon.clone();
      this.compCont.add(this.pon);
      this.pon.mats = [];

      this.pon.traverse((object) => {

        if ( object.isMesh ){

          this.pon.mats.push(object.material);
          object.material.transparent=true;
          object.material.opacity=0;
          object.material.visible=false;

        }

      });

      //--------------------------------------------------------

      this.count=0;
      this.action="wait"

      document.addEventListener("click", () => {

        if(this.action==="wait"){
          this.action="start"
        }
        
      })

      this.isPaused=false;

      document.getElementById("pauseBut").addEventListener("click", () => {

        if(this.isPaused===false){
          this.isPaused=true;
          gsap.globalTimeline.pause();
          document.getElementById("pauseBut").innerHTML = "resume";
        }else{
          this.isPaused=false;
          gsap.globalTimeline.resume();
          document.getElementById("pauseBut").innerHTML = "pause";
        }
        
      });

    }

    update(){

      this.tweenInSpeed = 1;
      this.spinSpeed = 10;

      if(this.action==="wait"){

        //

      }else if(this.action==="start boost"){

        this.action="start boost wait"

      }else if(this.action==="start boost wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>2 ){
          this.action="start";
        }

      }else if(this.action==="start"){

        gsap.to(this.myModel.position, { duration: this.tweenInSpeed, delay: 0, z: 0, y:0, ease: "sine.out" });
        gsap.to(this.door.rotation, { duration: 2, y: this.e.u.ca(160), ease: "sine.out" });

        document.getElementById("pauseBut").innerHTML = "pause";
        document.getElementById("pauseBut").style.pointerEvents = "auto";
        // gsap.to(document.getElementById("pauseBut"), { duration: this.tweenInSpeed/4, opacity: 1, ease: "linear" });

        gsap.to(this.darkPlane.material, { duration: 1, delay: .5, opacity: 0.8, ease: "linear" });

        this.count=0;
        this.action="start wait";

      }else if(this.action==="start wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>this.tweenInSpeed + 0){

          this.count=0;
          this.action="spin";

        }

      }else if(this.action==="spin"){

        gsap.to(this.myModel.rotation, { duration: this.spinSpeed, y: this.e.u.ca(155+360), ease: "sine.inOut" });

        this.action="spin wait";

      }else if(this.action==="spin wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>this.spinSpeed){

          this.count=0;
          this.action="fade parts"

        }

      }else if(this.action==="fade parts"){

        gsap.to(this.front.material, { duration: 1, opacity: 0, ease: "linear" });  
        gsap.to(this.grate.material, { duration: 1, opacity: 0, ease: "linear" });  
        gsap.to(this.innerCurved.material, { duration: 1, opacity: 0, ease: "linear" });  
        gsap.to(this.door1.material, { duration: 1, opacity: 0, ease: "linear" });  
        gsap.to(this.door2.material, { duration: 1, opacity: 0, ease: "linear" });  

        this.count=0;
        this.action="fade parts wait"

      }else if(this.action==="fade parts wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>1){

          this.front.material.visible=false;
          this.grate.material.visible=false;
          this.innerCurved.material.visible=false;
          this.door1.material.visible=false;
          this.door2.material.visible=false;

          this.count=0;
          this.action="show part 1"
          this.showCue=0;

        }

        //------------------------------------------------------------------

      }else if(this.action==="show part 1"){

        // this.compCont.position.z = 0;

        // reset all object sizes

        this.compCont.scale.x = this.compCont.scale.y = this.compCont.scale.z = .2;

        this.energyMonitor.scale.x = this.energyMonitor.scale.y = this.energyMonitor.scale.z = 0;
        this.breaker.scale.x = this.breaker.scale.y = this.breaker.scale.z = 0;
        this.pon.scale.x = this.pon.scale.y = this.pon.scale.z = 0;

        for(var i=0; i<this.energyMonitor.mats.length; i++){
          this.energyMonitor.mats[i].opacity=0;
          this.energyMonitor.mats[i].visible=false;
        }

        for(var i=0; i<this.breaker.mats.length; i++){
          this.breaker.mats[i].opacity=0;
          this.breaker.mats[i].visible=false;
        }

        for(var i=0; i<this.pon.mats.length; i++){
          this.pon.mats[i].opacity=0;
          this.pon.mats[i].visible=false;
        }

        // 

        if(this.showCue===0){
            
          for(var i=0; i<this.pon.mats.length; i++){

            this.pon.mats[i].visible=true;
            this.pon.mats[i].opacity=0;
            gsap.to(this.pon.mats[i], { opacity: 1, duration: 1, ease: "linear" }); 

          }

          this.pon.scale.x = this.pon.scale.y = this.pon.scale.z = 1;

        }else if(this.showCue===1){

          for(var i=0; i<this.energyMonitor.mats.length; i++){

            this.energyMonitor.mats[i].visible=true;
            this.energyMonitor.mats[i].opacity=0;
            gsap.to(this.energyMonitor.mats[i], { opacity: 1, duration: 1, ease: "linear" }); 

          }

          this.energyMonitor.scale.x = this.energyMonitor.scale.y = this.energyMonitor.scale.z = 1;

        }else if(this.showCue===2){

          for(var i=0; i<this.breaker.mats.length; i++){

            this.breaker.mats[i].visible=true;
            this.breaker.mats[i].opacity=0;
            gsap.to(this.breaker.mats[i], { opacity: 1, duration: 1, ease: "linear" }); 

          }

          this.breaker.scale.x = this.breaker.scale.y = this.breaker.scale.z = 1;

        }

        gsap.to(this.compCont.position, { y: 0, z: 5, duration: 1, ease: "sine.out" }); 
        gsap.to(this.compCont.scale, { x: .5, y: .5, z: .5, duration: 1, ease: "sine.out" }); 
        gsap.to(this.compCont.rotation, { x: this.e.u.ca(20), duration: 1, ease: "sine.out" }); 

        this.count=0;
        this.action="show part 1 wait";

      }else if(this.action==="show part 1 wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>2){

          this.count=0;
          this.action="spin part set"

        }

      }else if(this.action==="spin part set"){

          gsap.to(this.compCont.rotation, { y: this.compCont.rotation.y + this.e.u.ca(360), duration: 4, ease: "sine.inOut" }); 

          this.count=0;
          this.action="spin part wait"

      }else if(this.action==="spin part wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>4){

          this.count=0;
          this.action="spin part out set"

        }

      }else if(this.action==="spin part out set"){

        this.compCont.rotation.y -= this.e.u.ca(360);

        gsap.to(this.compCont.position, { y: this.compCont.starty, z: this.compCont.startz, duration: 1, ease: "sine.out" }); 
        gsap.to(this.compCont.scale, { x: .2, y: .2, z: .2, duration: 1, ease: "sine.out" }); 
        gsap.to(this.compCont.rotation, { x: this.e.u.ca(0), duration: 1, ease: "sine.out" }); 

        if(this.showCue===0){
            
          for(var i=0; i<this.pon.mats.length; i++){

            gsap.to(this.pon.mats[i], { opacity: 0, duration: 1, ease: "linear" }); 

          }

        }else if(this.showCue===1){

          for(var i=0; i<this.energyMonitor.mats.length; i++){

            gsap.to(this.energyMonitor.mats[i], { opacity: 0, duration: 1, ease: "linear" }); 

          }

        }else if(this.showCue===2){

          for(var i=0; i<this.breaker.mats.length; i++){

            gsap.to(this.breaker.mats[i], { opacity: 0, duration: 1, ease: "linear" }); 

          }

        }
      
        this.count=0;
        this.action="spin part out wait"

      }else if(this.action==="spin part out wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>4){

          this.count=0;

          this.showCue+=1;

          if(this.showCue<=2){
            this.action="show part 1"
          }else{
            this.action="fade parts restore"
          }

        }

        //------------------------------------------------------------------

      // }else if(this.action==="fade parts show"){

      //   if(this.isPaused===false){
      //     this.count+=this.e.dt;
      //   }

      //   if(this.count>4){

      //     this.count=0;
      //     this.action="fade parts restore"

      //   }

      }else if(this.action==="fade parts restore"){

        this.front.material.visible=true;
        this.grate.material.visible=true;
        this.innerCurved.material.visible=true;
        this.door1.material.visible=true;
        this.door2.material.visible=true;

        gsap.to(this.front.material, { duration: 1, opacity: 1, ease: "linear" });  
        gsap.to(this.grate.material, { duration: 1, opacity: 1, ease: "linear" });  
        gsap.to(this.innerCurved.material, { duration: 1, opacity: 1, ease: "linear" });   
        gsap.to(this.door1.material, { duration: 1, opacity: 1, ease: "linear" });  
        gsap.to(this.door2.material, { duration: 1, opacity: 1, ease: "linear" });  

        this.count=0;
        this.action="fade parts restore wait"

      }else if(this.action==="fade parts restore wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>1){

          this.count=0;
          this.action="out"

        }

      }else if(this.action==="out"){

        document.getElementById("pauseBut").style.pointerEvents = "none";
        gsap.to(document.getElementById("pauseBut"), { duration: this.tweenInSpeed/4, opacity: 0, ease: "linear" });

        gsap.to(this.myModel.rotation, { duration: 2, y: this.e.u.ca(135+360), delay: 1, ease: "sine.out" });

        gsap.to(this.door.rotation, { duration: 2, y: this.e.u.ca(0), delay: 1, ease: "sine.out" });
        gsap.to(this.myModel.position, { duration: this.tweenInSpeed, delay: 1, z: -15, y:1, ease: "sine.out" });

        gsap.to(this.darkPlane.material, { duration: this.tweenInSpeed/2, opacity: 0, ease: "sine.out" });

        this.count=0;
        this.action="out wait";

      }else if(this.action==="out wait"){

        if(this.isPaused===false){
          this.count+=this.e.dt;
        }

        if(this.count>this.tweenInSpeed + 2.5){
          this.qo.rotation.y = this.e.u.ca(135);
          // this.myModel.rotation.y = this.e.u.ca(58);
          this.count=0;
          this.action="wait";

        }

      }

      if(this.darkPlane.material.opacity===0){
        this.darkPlane.material.visible=false;
      }else{
        this.darkPlane.material.visible=true;
      }

      // this.mixer()

    }

        //------------------------------------------------------------------

        

    mixer(){

      if(document.getElementById("mix").checked === true){
  
          //-------------------------------------
  
          var c1_H = document.getElementById("c1_H").value;
          var c1_S = document.getElementById("c1_S").value;
          var c1_L = document.getElementById("c1_L").value;
  
          document.getElementById("c1_Color").value = this.e.u.hslToHex(c1_H,c1_S,c1_L);
          // this.rig.material.color.setHex( "0x"+this.e.u.hslToHex(c1_H,c1_S,c1_L) );
  
          //-------------------------------------
  
          var c2_H = document.getElementById("c2_H").value;
          var c2_S = document.getElementById("c2_S").value;
          var c2_L = document.getElementById("c2_L").value;
  
          document.getElementById("c2_Color").value = this.e.u.hslToHex(c2_H,c2_S,c2_L);
          // this.roofBars.material.color.setHex( "0x"+this.e.u.hslToHex(c2_H,c2_S,c2_L) );
          
          //-------------------------------------
  
          var c3_H = document.getElementById("c3_H").value;
          var c3_S = document.getElementById("c3_S").value;
          var c3_L = document.getElementById("c3_L").value;
  
          document.getElementById("c3_Color").value = this.e.u.hslToHex(c3_H,c3_S,c3_L);
          // this.roofEdge.material.color.setHex( "0x"+this.e.u.hslToHex(c3_H,c3_S,c3_L) );
          
          //-------------------------------------
  
          var c4_H = document.getElementById("c4_H").value;
          var c4_S = document.getElementById("c4_S").value;
          var c4_L = document.getElementById("c4_L").value;
  
          document.getElementById("c4_Color").value = this.e.u.hslToHex(c4_H,c4_S,c4_L);
          // this.ambLight.color.setHex( "0x"+this.e.u.hslToHex(c4_H,c4_S,c4_L) );
  
          //-------------------------------------
  
          var c5_H = document.getElementById("c5_H").value;
          var c5_S = document.getElementById("c5_S").value;
          var c5_L = document.getElementById("c5_L").value;
  
          document.getElementById("c5_Color").value = this.e.u.hslToHex(c5_H,c5_S,c5_L);
  
          //-------------------------------------
  
          var num1 = document.getElementById("num1").value;
          var num2 = document.getElementById("num2").value;
          var num3 = document.getElementById("num3").value;
  
          // this.dl_shad.position.x = num1;
          // this.dl_shad.position.z = num2;
          // this.dl_shad.position.y = num3;
  
      }

    }

}